export default {
  namespaced: true,
  profiles: {
    title: "perfil | perfiles",
    description: "descripcion",
    forced_layouts: "forzar layouts",
    session_time: "Tiempo de sesión en horas",
    priority:"Prioridad de Control PTZ",
    priority_helper:"Los números más bajos significan mayor prioridad.",
    inactivity_lifetime: "Tiempo límite de inactividad en minutos",
    clone_title: "Clonar perfil",
    new_name: "Nuevo nombre",
    clone_success: "Perfil clonado correctamente",
  },
};
